import React from 'react';
import ReactDOM from 'react-dom/client';
import {useContext, useEffect, useState} from 'react';
import {createBrowserRouter, RouterProvider, useNavigate} from 'react-router-dom';
import './index.css';
import {PostHogProvider} from 'posthog-js/react';
import posthog from 'posthog-js';
import reportWebVitals from './reportWebVitals';
import {LoginPage} from './pages/Auth/Login/login';

import {GuestLogin} from './pages/Auth/GuestLogin/guestlogin';
import {GuestDemographics} from './pages/Guest/guestDemographics.js';
import {EmailPage} from './pages/Email/email.js';
import {ThankYouGuestPage} from './pages/Thankyou/thankyouguest.js';

import {ResultsPage} from './pages/Results/resultspage';

import {HeartHealthAnalysisPage} from './pages/Analysis/hearthealthanalysis';
import {Bodyfunctionanalysis} from './pages/Analysis/bodyfunctionanalysis';
import {PhysicalHealthAnalysis} from './pages/Analysis/physicalhealthanalysis';
import {Diseaseriskanalysis} from './pages/Analysis/diseaseriskanalysis';
import {LiverHealthAnalysis} from './pages/Analysis/liverhealthanalysis';
import {DiabetesRiskAnalysis} from './pages/Analysis/diabetesriskanalysis';
import {RegisterPage} from './pages/Auth/Register/register';
import {VerifyEmailPage} from './pages/Auth/Verify/verifyEmail';
import {ResultsInitialPage} from './pages/Symptoms/Questionnaire/resultsInit';
import {DermadetectFormPage} from './pages/Dermadetect/dermadetectForm';
import {HehealthFormPage} from './pages/HeHealth/hehealthForm';
import {ThankYouPage} from './pages/Symptoms/Questionnaire/thankYou';
import {FinalResultsPage} from './pages/Symptoms/Questionnaire/finalResults';
import ContextsWrapper from './ContextsWrapper';
import {DashboardPage} from './pages/Dashboard/dashboard';
import {PricingOptionsBase} from './pages/PricingOptions/pricing';
import {PrivacyPage} from './pages/TermsAndPrivacy/privacy';
import {TermsOfServicePage} from './pages/TermsAndPrivacy/termsOfService';
import {CoughSymptomCheckerPage} from './pages/RespiratorySymptoms/coughSymptomChecker';
import {CheckedConfirmationPage1} from './pages/RespiratorySymptoms/checkConfirmationStep1';
import {HandlingAPIToolRedirection} from './routes/continue.js';
import {VerifyPhonePage} from './pages/Auth/Verify/verifyPhone';
import {ErrorPage} from './pages/Error/errorPage';
import {NullErrorPage} from './pages/Error/nullError';
import {ChangePasswordPage} from './pages/Auth/ChangePass/changePass';
import {ForgotPassword} from './pages/Auth/ChangePass/forgotPassword';
import MiscContext from './context/MiscContext';
import {PrivateAccess} from './routes/privateAccess';
import {Page404} from './pages/Error/page404';
import {TwoFactorAuthRealPage} from './pages/Auth/2FA/TwoFactorAuthPage';
import {AuthenticatePage} from './pages/Auth/2FA/authenticatePage';
import {ProfilePage} from './pages/profile/personalInfo';
import {DemographicPageAccess} from './routes/demographicPageAccess';
import {SymptomCheckerAccess} from './routes/symptomCheckerAccess';
import {SkinErrorPage} from './pages/Error/skinError.js';
import {AnalysisPage} from './pages/Results/Components/analysis/analysispage.js';
import GuestPreFaceScan from './pages/Guest/guestPreFaceScan.js';
import {GuestSymptomChecker} from './pages/Guest/guestSymptomChecker.js';

import {DoktorLanding} from './pages/DoktorConnect/DoktorLanding.js';
import {DoktorSymptomChecker} from './pages/DoktorConnect/DoktorSymptomChecker.js';
import {DoktorPreFaceScan} from './pages/DoktorConnect/DoktorPreFaceScan.js';
import {DoktorDemographics} from './pages/DoktorConnect/DoktorDemographics.js';
import {DoktorHandlingAPIToolRedirection} from './routes/doktorcontinue.js';

//ATPL ROutes
import {AtplLanding} from './pages/AtpLab/AtplLanding.js';
import {AtplDemographics} from './pages/AtpLab/AtplDemographics.js';
import {AtplPreScanScreen} from './pages/AtpLab/AtplPreScanScreen.js';
import {AtplHealthProfileQue} from './pages/AtpLab/AtplHealthProfileQue.js';
import AtplCart from './pages/AtpLab/AtplCart.js';

import AtplResult from './pages/AtpLab/AtplResult.js';
import AtplSymptomChecker from './pages/AtpLab/AtplSymptomChecker.js';
import GuestDemographics2 from './pages/Guest/guestDemographics2.js';
// import UserFlowQuestionnaire from './pages/Symptoms/Questionnaire/userFlowQuestionnaire.js';
import {PreFaceScanPage} from './pages/AimdUserFlow/preFaceScan.js';
import AimdSymptomChecker from './pages/AimdUserFlow/aimdSymptomChecker.js';
import EditOrScanPage from './pages/AimdUserFlow/editOrScanPage.js';
import UserFlowQuestionnaire from './pages/AimdUserFlow/userFlowQuestionnaire.js';

import PrisingScreen from './pages/AimdUserFlow/prisingScreen.js';
import RevealResultsScreen from './pages/AimdUserFlow/revealResultsScreen.js';
import {ClientProvider} from './context/ClientContext.js';
import MasterDemographicsPage from './components/master/demographics/MasterDemographicsPage.js';
import MasterHealthProfilePage from './components/master/healthProfile/MasterHealthProfilePage.js';
import MasterSymptomCheckerPage from './components/master/symptomChecker/MasterSymptomCheckerPage.js';
import MasterLanding from './components/master/Landing/Masterlanding.js';
import MasterPreFaceScan from './components/master/preFaceScan/MasterPreFaceScan.js';
import MasterFaceScanErrorPage from './components/master/common/Masterfacescanerrorpage.js';
import DermatologyScreening from './pages/AimdUserFlow/aimdSkyn.js';
import {HelloHealthResultsPage} from './pages/NewResults/organizations/HelloHealthResults/HelloHealthResultsPage.js';
import {AtplResultsPage} from './pages/NewResults/organizations/AtplResults/AtplResultsPage.js';

// Custom route component for protecting the /dashboard route
const ProtectedDashboardRoute = ({element}) => {
  const {userEmail, userPlan} = useContext(MiscContext);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('index useEffect');
    if (userEmail !== '' && userPlan !== 'premium') {
      navigate(-1);
    }
  }, [userEmail, userPlan, navigate]);

  // Check if the user is authenticated and has a premium plan
  if (userEmail !== '' && userPlan === 'premium') {
    return element;
  } else {
    // Redirect to previous route if user is not premium.
    return null;
  }
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <ContextsWrapper />,
    children: [
      {
        path: 'start',
        element: <GuestLogin />,
      },
      {
        path: 'user-login',
        element: <LoginPage />,
      },
      {
        path: 'guest-demographics',
        element: <GuestDemographics2 />,
      },
      {
        path: 'guest-pre-face-scan',
        element: <GuestPreFaceScan />,
      },
      {
        path: 'guest-symptom-checker',
        element: <GuestSymptomChecker />,
      },
      {
        path: 'email-page',
        element: <EmailPage />,
      },
      {
        path: 'thank_you',
        element: <ThankYouPage />,
      },
      {
        path: 'register',
        element: <RegisterPage />,
      },
      {
        path: 'verify-email',
        element: <VerifyEmailPage />,
      },
      {
        path: 'verify-phone',
        element: <VerifyPhonePage />,
      },
      {
        path: 'demographics',
        element: <DemographicPageAccess element={<UserFlowQuestionnaire />} />,
      },
      // {
      //   path: 'demographics',
      //   element: <UserFlowQuestionnaire />,
      // },
      {
        path: 'pre-results',
        element: <ResultsInitialPage />,
      },
      {
        path: 'skin-condition',
        element: <PrivateAccess element={<DermadetectFormPage />} />,
      },
      {
        path: 'skyn-condition-checker',
        element: <DermatologyScreening />,
      },
      {
        path: 'symptom-checker',
        element: <SymptomCheckerAccess element={<AimdSymptomChecker />} />,
      },
      {
        path: 'edit-or-scan',
        element: <EditOrScanPage />,
      },

      {
        path: 'hellohealth-results',
        element: <HelloHealthResultsPage />,
      },

      {
        path: 'atpl-results',
        element: <AtplResultsPage />,
      },
      {
        path: 'thank-you',
        element: <ThankYouGuestPage />,
      },
      {
        path: 'results',
        element: <ResultsPage />,
      },
      {
        path: 'client-results/:sessionId',
        element: <ResultsPage />,
      },
      {
        path: 'results/analysis',
        element: <AnalysisPage />,
      },
      {
        path: 'heart-health-analysis',
        element: <HeartHealthAnalysisPage />,
      },
      {
        path: 'body-function-analysis',
        element: <Bodyfunctionanalysis />,
      },
      {
        path: 'physical-health-analysis',
        element: <PhysicalHealthAnalysis />,
      },
      {
        path: 'disease-risk-analysis',
        element: <Diseaseriskanalysis />,
      },
      {
        path: 'liver-health-analysis',
        element: <LiverHealthAnalysis />,
      },
      {
        path: 'diabetes-risk-analysis',
        element: <DiabetesRiskAnalysis />,
      },

      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'pricing',
        element: <PricingOptionsBase />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPage />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfServicePage />,
      },
      {
        path: 'pre-face-scan',
        element: <PreFaceScanPage />,
      },
      {
        path: 'cough-symptoms',
        element: <PrivateAccess element={<CoughSymptomCheckerPage />} />,
      },
      {
        path: 'recording-confirmation-1',
        element: <PrivateAccess element={<CheckedConfirmationPage1 />} />,
      },
      {
        path: 'authenticate-email',
        element: <AuthenticatePage factor="email" />,
      },
      {
        path: 'authenticate-phone',
        element: <AuthenticatePage factor="phone" />,
      },
      // TODO: The continue path needs to be removed, as it does not provide any UI.
      {
        path: 'continue',
        element: <HandlingAPIToolRedirection />,
      },
      {
        path: 'plans',
        element: <PrisingScreen />,
      },
      // {
      //   path: 'plans',
      //   element: < RevealResultsScreen />,
      // },

      {
        path: 'doktor-continue',
        element: <DoktorHandlingAPIToolRedirection />,
      },
      {
        path: 'face-scan-generic-error',
        element: <ErrorPage />,
      },
      {
        path: 'face-scan-null-error',
        element: <NullErrorPage />,
      },
      {
        path: 'skin-condition-error',
        element: <SkinErrorPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
      {
        path: 'password-reset/:token',
        element: <ChangePasswordPage />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'men-sexual-health',
        element: <PrivateAccess element={<HehealthFormPage />} />,
      },
      {
        path: 'multifactor',
        element: <TwoFactorAuthRealPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },

      {
        path: 'doktorlanding',
        element: <DoktorLanding />,
      },

      {
        path: 'doktor-symptom-checker',
        element: <DoktorSymptomChecker />,
      },

      {
        path: 'doktor-pre-face-scan',
        element: <DoktorPreFaceScan />,
      },

      {
        path: 'doktor-demographics',
        element: <DoktorDemographics />,
      },

      //ATPL ROUTES
      {
        path: 'atpllanding',
        element: <AtplLanding />,
      },
      {
        path: 'atpl-demographics',
        element: <AtplDemographics />,
      },
      {
        path: 'atpl-pre-face-scan',
        element: <AtplPreScanScreen />,
      },
      {
        path: 'atpl-symptom-checker',
        element: <AtplSymptomChecker />,
      },
      {
        path: 'atpl-health-profile',
        element: <AtplHealthProfileQue />,
      },
      {
        path: 'atpl-results',
        element: <AtplResult />,
      },

      {
        path: 'atpl-cart',
        element: <AtplCart />,
      },
      {
        path: 'hellohealth-landing',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterLanding />
          </ClientProvider>
        ),
      },
      {
        path: '/hellohealth-demographics',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterDemographicsPage />
          </ClientProvider>
        ),
      },
      {
        path: 'hellohealth-pre-face-scan',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterPreFaceScan />
          </ClientProvider>
        ),
      },
      {
        path: '/client-b-demographics',
        element: (
          <ClientProvider clientId="clientB">
            <MasterDemographicsPage />
          </ClientProvider>
        ),
      },
      {
        path: '/hellohealth-health-profile',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterHealthProfilePage />
          </ClientProvider>
        ),
      },
      {
        path: '/hellohealth-symptom-checker',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterSymptomCheckerPage />
          </ClientProvider>
        ),
      },
      {
        path: '/face-scan-error-page',
        element: (
          <ClientProvider clientId="hellohealth">
            <MasterFaceScanErrorPage />
          </ClientProvider>
        ),
      },
    ],
  },
]);

//posthog host
const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
      <RouterProvider router={router} />
    </PostHogProvider>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
